'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertMessage = function AlertMessage(props) {
  if (typeof props.msg === 'string' && props.msg.indexOf('<script') === -1) {
    return _react2.default.createElement('div', { className: 'pxl-alert__message', dangerouslySetInnerHTML: { __html: props.msg } });
  }
  return _react2.default.createElement(
    'div',
    { className: 'pxl-alert__message' },
    props.msg
  );
};

AlertMessage.propTypes = {
  msg: _propTypes2.default.any
};

exports.default = AlertMessage;